import { render, staticRenderFns } from "./simple-line.vue?vue&type=template&id=381a8978"
import script from "./simple-line.vue?vue&type=script&lang=js"
export * from "./simple-line.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports